import { render, staticRenderFns } from "./prd.vue?vue&type=template&id=5c140f34&scoped=true"
import script from "./prd.vue?vue&type=script&lang=js"
export * from "./prd.vue?vue&type=script&lang=js"
import style0 from "./prd.vue?vue&type=style&index=0&id=5c140f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c140f34",
  null
  
)

export default component.exports